module.exports = __webpack_public_path__ + "media/hero-image.fd80b70f.png";